// extracted by mini-css-extract-plugin
export default {"badge-height":"_14wrjg5","badgeHeight":"_14wrjg5","badge-border":"_1285flm","badgeBorder":"_1285flm"};